var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{attrs:{"bordered":false}},[_c('div',[_c('a-table',{ref:"table",attrs:{"size":"middle","bordered":"","rowKey":"id","columns":_vm.columns,"dataSource":_vm.dataSource,"pagination":_vm.ipagination,"loading":_vm.loading},on:{"change":_vm.handleTableChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }